import { StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [];

export const styleDefaults = new Map<string, string>();

export const stylePropertiesForTheme: Array<StylePropertyDefinition> = [
	{
		cp: 'color',
		sel: '.comp.compCheckbox<designType><colorScheme>',
		np: true,
		spv: {
			'_outlined-_primary': '<fontColorThree>',
			'_outlined-_secondary': '<fontColorFour>',
			'_outlined-_tertiary': '<fontColorFive>',
			'_outlined-_quaternary': '<fontColorNine>',
			'_outlined-_quinary': '<fontColorSeven>',
			'_filled-_primary': '<fontColorThree>',
			'_filled-_secondary': '<fontColorFour>',
			'_filled-_tertiary': '<fontColorFive>',
			'_filled-_quaternary': '<fontColorNine>',
			'_filled-_quinary': '<fontColorSeven>',
		},
		gn: 'Color',
		dn: 'Color',
		n: 'checkBoxColor<designType><colorScheme>',
	},
	{
		cp: 'border',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox',
		np: true,
		spv: {
			'_default-': 'none',
			'_outlined-': '2px solid',
			'_filled-': '2px solid',
		},
		gn: 'Border',
		dn: 'Border CommonCheckbox',
		n: 'checkBoxBorderCommonCheckbox<designType><colorScheme>',
	},
	{
		// The box's corner rounding was hard-coded at 2px in CheckBoxStyle.tsx, so a
		// theme could restyle everything about the checkbox except its shape. The
		// default here is that same 2px, so no existing screen moves.
		cp: 'border-radius',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox',
		np: true,
		spv: {
			'_default-': '2px',
			'_outlined-': '2px',
			'_filled-': '2px',
		},
		gn: 'Border',
		dn: 'Border Radius CommonCheckbox',
		n: 'checkBoxBorderRadiusCommonCheckbox<designType><colorScheme>',
	},
	{
		cp: 'border-color',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox',
		np: true,
		spv: {
			'_outlined-_primary': '<fontColorThree>',
			'_outlined-_secondary': '<fontColorFour>',
			'_outlined-_tertiary': '<fontColorFive>',
			'_outlined-_quaternary': '<fontColorNine>',
			'_outlined-_quinary': '<fontColorSeven>',
			'_filled-_primary': '<fontColorThree>',
			'_filled-_secondary': '<fontColorFour>',
			'_filled-_tertiary': '<fontColorFive>',
			'_filled-_quaternary': '<fontColorNine>',
			'_filled-_quinary': '<fontColorSeven>',
		},
		gn: 'Border Color',
		dn: 'BorderColor CommonCheckbox',
		n: 'checkBoxBorderColorCommonCheckbox<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox',
		np: true,
		spv: {
			'_default-_primary': '<backgroundColorOne>',
			'_default-_secondary': '<backgroundColorTwo>',
			'_default-_tertiary': '<backgroundColorThree>',
			'_default-_quaternary': '<backgroundColorFour>',
			'_default-_quinary': '<backgroundColorFive>',
			'_outlined-': '<backgroundColorSeven>',
		},
		gn: 'Background',
		dn: 'Background CommonCheckbox',
		n: 'checkBoxBackgroundCommonCheckbox<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox ._thumb',
		np: true,
		spv: {
			'_outlined-_primary': '<fontColorThree>',
			'_outlined-_secondary': '<fontColorFour>',
			'_outlined-_tertiary': '<fontColorFive>',
			'_outlined-_quaternary': '<fontColorNine>',
			'_outlined-_quinary': '<fontColorSeven>',
			'_default-': '<backgroundColorSeven>',
			'_filled-': '<backgroundColorSeven>',
		},
		gn: 'Background',
		dn: 'Background Thumb',
		n: 'checkBoxBackgroundThumb<designType><colorScheme>',
	},
	{
		cp: 'border',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox._checked',
		np: true,
		spv: {
			'_default-': 'none',
			'_outlined-': '2px solid',
			'_filled-': '2px solid',
		},
		gn: 'Border',
		dn: 'Border Checked',
		n: 'checkBoxBorderChecked<designType><colorScheme>',
	},
	{
		cp: 'border-color',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox._checked',
		np: true,
		spv: {
			'_outlined-_primary': '<fontColorThree>',
			'_outlined-_secondary': '<fontColorFour>',
			'_outlined-_tertiary': '<fontColorFive>',
			'_outlined-_quaternary': '<fontColorNine>',
			'_outlined-_quinary': '<fontColorSeven>',
			'_filled-_primary': '<fontColorThree>',
			'_filled-_secondary': '<fontColorFour>',
			'_filled-_tertiary': '<fontColorFive>',
			'_filled-_quaternary': '<fontColorNine>',
			'_filled-_quinary': '<fontColorSeven>',
		},
		gn: 'Border Color',
		dn: 'BorderColor Checked',
		n: 'checkBoxBorderColorChecked<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox._checked',
		np: true,
		spv: {
			'_filled-_primary': '<backgroundColorOne>',
			'_filled-_secondary': '<backgroundColorTwo>',
			'_filled-_tertiary': '<backgroundColorThree>',
			'_filled-_quaternary': '<backgroundColorFour>',
			'_filled-_quinary': '<backgroundColorFive>',
		},
		gn: 'Background',
		dn: 'Background Checked',
		n: 'checkBoxBackgroundChecked<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox._disabled ._thumb',
		np: true,
		dv: '<fontColorEight>',

		gn: 'Background',
		dn: 'Background Disabled Thumb',
		n: 'checkBoxBackgroundDisabledThumb<designType><colorScheme>',
	},
	{
		cp: 'border-color',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox._disabled',
		np: true,
		spv: {
			'_outlined-': '<fontColorEight>',
			'_filled-': '<fontColorEight>',
		},
		gn: 'Border Color',
		dn: 'BorderColor Disabled',
		n: 'checkBoxBorderColorDisabled<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compCheckbox<designType><colorScheme> .commonCheckbox._disabled',
		np: true,
		spv: {
			'_default-': '<backgroundColorEight>',
			'_filled-': '<backgroundColorEight>',
		},
		gn: 'Background',
		dn: 'Background CommonCheckbox Disabled',
		n: 'checkBoxBackgroundCommonCheckBoxDisabled<designType><colorScheme>',
	},
	{
		cp: 'font',
		sel: '.comp.compCheckbox<designType><colorScheme> label',
		np: true,
		spv: {
			'_default-': '<primaryFont>',
			'_outlined-': '<primaryFont>',
			'_filled-': '<primaryFont>',
		},
		gn: 'Font',
		dn: 'Font',
		n: 'checkBoxFont<designType><colorScheme>',
	},
	{
		cp: 'color',
		sel: '.comp.compCheckbox<designType><colorScheme> label._disabled',
		np: true,
		spv: {
			'_outlined-': '<fontColorEight>',
		},
		gn: 'Color',
		dn: 'Color Disabled',
		n: 'checkBoxColorDisabled<designType><colorScheme>',
	},
];
